<template lang="pug">
#Result(v-if="item" style="flex: 1 1")
    v-list-item(@click="$emit('click')" active-class="selected")
        v-list-item-icon
            div.service-type.flex-none
                img.w2.ml2.mr2(:src="p.icon")

        .result.w-100.pointer(:data-serviceId="p.id" :class="{ selected }")
            .flex
                div(style="flex: 1 0")
                    .org-name {{ p.orgName }}
                    template(v-if="selected")
                        div.i(v-if="p.phoneService")
                            p This service is provided by telephone.
                        div.i(v-else-if="p.type === 'servicePoint'")
                            p This organisation services {{ groupProperties.locationName }}.
                        template(v-else-if="p.type==='organisation'")
                            .org-address.mb2(v-if="p.orgAddress")
                                span {{ p.orgAddress }}

                    .org-phone(v-if="!selected && p.orgPhone")
                        span <small>📞</small>{{ p.orgPhone }}
                    template(v-if="selected")
                        .org-phone(v-if="p.orgPhone")
                            span.mr2 <small>📞</small>
                            | <a :href="`tel:${p.orgPhone}`">{{ p.orgPhone }}</a>
                        .org-email(v-if="p.orgEmail")
                            span.mr2 <small>✉️</small>
                            | <a :href="`mailto:${p.orgEmail}`">{{ p.orgEmail }}</a>
                        .tc.mt2
                            v-btn(text)
                                a(:href="fullUrl(p.orgUrl)" target="_blank") Open website
                    .tc
                        v-btn.mt2(color="primary" v-if="selected && windowWidth < 720 && !p.phoneService" @click="showOnMap(item)") See on map
                .flex-none
                    img(v-if="p.orgLogo" width="60" :src="orgLogo")
</template>

<script>
import { EventBus } from '@/EventBus';
export default {
    name: 'Result',
    props: ['item', 'selected', 'groupProperties', 'windowWidth'],
    data: () => ({}),
    created() {
        window.Result = this;
    },
    computed: {
        p() {
            return this.item && this.item.properties;
        },
        orgLogo() {
            if (!this.p || !this.p.orgLogo) {
                return '';
            }
            if (this.p.orgLogo.match(/^http/)) {
                return this.p.orgLogo;
            } else {
                return `http://mapswell.site44.com/kimberley-supports/org-logos/${this.p.orgLogo}`;
            }
        },
    },
    methods: {
        showOnMap(item) {
            EventBus.$emit('showOnMap', item);
        },
        shortUrl(url) {
            return url.replace(/(.*\/\/)?([a-zA-Z0-9-_.]+).*/, '$2');
        },
        fullUrl(url) {
            if (url.match(/^http/)) {
                return url;
            } else {
                return 'https://' + url;
            }
        },
    },
};
</script>

<style>
.v-list-item {
    padding: 0 !important;
}
</style>

<style>
.result {
    border: 2px solid transparent;
    padding: 4px;
    width: 100%;
}

.result.selected {
    padding: 30px 4px;
    background: hsl(200, 60%, 95%);
    border-top: 2px solid hsl(200, 60%, 60%);
    border-bottom: 2px solid hsl(200, 60%, 60%);
}
</style>
